// Login.jsx

import React, { useState, useContext } from 'react';
import { AuthContext } from '../config/AuthProvider';
import { appConfig } from '../config/appConfig';
import { Navigate } from 'react-router-dom';

function Login() {
  const { currentUser, isAdmin, login } = useContext(AuthContext);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loginError, setLoginError] = useState('');

  if (currentUser && isAdmin) {
    return <Navigate to="/sati" replace />;
  }
  if (currentUser && !isAdmin) {
    return <Navigate to="/moj-tjedan" replace />;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await login((email || '').trim().toLowerCase(), password);
      // Nakon uspješne prijave, ProtectedRoute će provjeriti admin status
    } catch (e) {
      console.error('Error during login:', e);
      setLoginError('Pogreška prilikom prijave. Provjerite email i lozinku.');
    }
  };

  return (
    <form className="login-form" onSubmit={handleSubmit}>
      <h1 className="login-app-title">{appConfig.appTitle}</h1>
      <h2>Prijava</h2>
      {loginError && <p style={{ color: 'red' }}>{loginError}</p>}
      <input
        type="email"
        placeholder="Email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        required
      />
      <input
        type="password"
        placeholder="Lozinka"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        required
      />
      <button type="submit">Prijava</button>
    </form>
  );
}

export default Login;
